export const updateTDP = (action)=>{
    return {
        type: "UPDATE_TDP",
        payload: action
    }
};
